import {PropsWithChildren} from "react";
import {css, cx} from "@panda/css";

import {prettyScroll} from "../../../../styles/receipes/pretty_scroll";

interface IProps {
    isScrollable?: boolean;
    prettyScrollStyle?: boolean;
}

export const ApplicationMultiLeadWrapper = (props: PropsWithChildren<IProps>) => {
    return (
        <div className={cx(wrapper, props.isScrollable ? scrollableStyle : overflowHiddenStyle, props.prettyScrollStyle && css(prettyScroll))}>
            {props.children}
        </div>
    );
};

const wrapper = css({
    borderRadius: 2,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    height: "100%"
});

const scrollableStyle = css({
    overflow: "auto"
});

const overflowHiddenStyle = css({
    overflow: "hidden"
});
